import styled from 'styled-components';
import PropTypes from 'prop-types';

const T2R = styled.span`
  font-weight: 400;
  color: ${props => props.color};
`;

T2R.propTypes = {
  color: PropTypes.string
};

export default T2R;
